import { actions } from './actions'

const initialState = {
  reclamaciones: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function reclamacionesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.RECLAMACIONES_LOAD_REQUESTED:
      return { ...state, reclamaciones: { ...state.reclamaciones, loading: true } }
    case actions.RECLAMACIONES_LOAD_SUCCEEDED:
      return {
        ...state,
        reclamaciones: { ...state.reclamaciones, data: action.payload, loading: false },
      }
    case actions.RECLAMACIONES_LOAD_FAILED:
      return {
        ...state,
        reclamaciones: { ...state.reclamaciones, loading: false, error: action.error },
      }
    default:
      return state
  }
}
